import React from "react";
import { createFromIconfontCN } from "@/utils/antdIcon";
import colors from "@/components/styles/colors";

import taskPng1 from "./standardization/task_communicate.png";
import taskPng2 from "./standardization/task_preserve.png";
import taskPng3 from "./standardization/task_proceed.png";
import taskPng4 from "./standardization/task_restart.png";
import windowPop from "./standardization/window_pop.png";
export const IconTaskCommunicate = <img src={taskPng1} />;
export const IconTaskPreserve = <img src={taskPng2} />;
export const IconTaskProceed = <img src={taskPng3} />;
export const IconTaskRestart = <img src={taskPng4} />;
export const IconWindowPop = <img src={windowPop} />;

export { default as DefaultUserAvatar } from "../../assets/img/default_avatar.png";
export { default as DefaultTeamAvatar } from "../../assets/img/group_default_avatar.png";

const { PUBLIC_URL } = process.env;
const IconFont = createFromIconfontCN({
  extraCommonProps: {
    // style: {
    //   fontSize: "14px",
    //   color: "rgba(129, 135, 147, 1)"
    // }
  },
  scriptUrl: PUBLIC_URL ? `${PUBLIC_URL}/iconfont.js` : "/iconfont.js" // '//at.alicdn.com/t/font_1717591_5fs7ttlpnm6.js',
});

export default IconFont;

export const IconFresh = <IconFont type="iconjs_ic_break" />;
export const IconSearch = <IconFont type="iconquanjusousuo" style={{ fontSize: 16}}/>;
export const IconAppointMeeting = <IconFont type="iconapp_btn_joymeeting_video" />;
export const IconWebAddres = <IconFont type="iconpc_ic_webaddres_kuangjia" />;
export const IconHoutai = <IconFont type="iconhoutai" />;

export const IconCloseEye = <IconFont type="iconzw_web_eye_closed" />;
export const IconTitleRight = <IconFont type="iconic_joyday_title_dropdown" />;

export const IconChat = <IconFont type="iconic_chat" />;
export const IconMultimedia = <IconFont type="iconapp_btn_joymeeting_video" />; // TODO: 临时使用该图标
export const IconShare = <IconFont type="iconapp_btn_peopleshare" />;
export const IconJoyspace = <IconFont type="iconapp_ic_bardoc" />;
export const IconCalendar = <IconFont type="iconic_day" />;
export const IconWork = <IconFont type="iconbacklog" />;
export const IconThirdApp = <IconFont type="iconapp_tabbar_application" />;
export const IconHomeApp = <IconFont type="iconshouye" />;
export const IconClose = <IconFont type="iconwin_Close" />;
export const IconRefresh = <IconFont type="iconbtn_reduction" />;
export const IconEBook = <IconFont type="iconapp_btn_addressbook" />;
export const IconMail = <IconFont type="iconapp_btn_pc_mail" />;
export const IconSetup = <IconFont type="iconapp_btn_Setup" />;
export const IconArrowRight = <IconFont type="iconapp_ic_arrow_right" />;
export const IconArrowRightLayout = <IconFont type="iconFrame6" />;
export const IconMore = <IconFont type="iconwin_more" />;
export const IconEdit = <IconFont type="iconapp_btn_edit" />;
export const IconRdit = <IconFont type="iconkefu" style={{ fontSize: "20px", color: 'rgba(252, 167, 0, 1)'}}/>;
export const IconFailure = <IconFont type="iconic_failure" />;
export const IconSet = <IconFont type="iconxitongshezhi" style={{ fontSize: "20px", color: 'rgba(69, 0, 228, 1)'}}/>;
export const IconExit = <IconFont type="icontuichudenglu" style={{ fontSize: "20px", color: 'rgba(0, 188, 182, 1)'}} />;
export const IconManager = <IconFont type="iconiconbtn_manager" />;
export const IconAdd = <IconFont type="iconbtn_add" />;
export const IconGroup = <IconFont type="icona-statequnzu" style={{ fontSize: "20px", color: "rgba(129, 135, 147, 1)"}} />;
export const IconMeeting = <IconFont type="iconapp_ic_Joymeeting" />;
export const IconJoinMeeting = <IconFont type="iconapp_ic_join_meeting" />;
export const IconCopyBtn = <IconFont type="iconweb_btn_copy" />;
export const IconZhuanban = <IconFont className="create-zhuanban-icon" type="iconzw_app_project" />;
export const IconMute = <IconFont type="iconmute" />;
export const IconDocHome = <IconFont type="iconapp_ic_dochome" />;
export const IconMyDoc = <IconFont type="iconapp_ic_mydoc" />;
export const IconMobilePhone = <IconFont type="iconic_mobilephone" />;
// 收藏
export const IconKeep = <IconFont type="iconic_yipingfen" />;
export const IconCancelKeep = <IconFont type="iconic_pingfen" />;
// 圆加号
export const IconAddApp = <IconFont type="iconapp_btn_add" />;
// 圆取消
export const IconCircleClose = <IconFont type="iconjs_ic_error" />;
// 搜索
// export const IconSearch = <IconFont type="iconic_search" />;

export const IconRemind3 = <IconFont type="iconzw_app_remind3" />; // 催办小铃铛图标
// export const IconlogDown = <IconFont type="iconlog_down" />;
export const IconDefualtOrg = (
  <div
    style={{
      color: "#fff",
      backgroundColor: `${colors.primary2}`,
      borderRadius: 8,
      height: 36,
      width: 36,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }}
  >
    <IconFont type="iconapp_btn_cha" />
  </div>
);

export const IconDefualtWorkLine = (
  <div
    style={{
      color: "#fff",
      backgroundColor: `${colors.primary2}`,
      borderRadius: 8,
      height: 36,
      width: 36,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }}
  >
    <IconFont type="icontiaoxian2" style={{ fontSize: 18 }} />
  </div>
);
export const IconRight = <IconFont type="iconapp_ic_arrow_right" />;

export const IconArrowLeft = <IconFont type="iconwin_left" />;
export const IconJoyMeetingGroup = <IconFont type="icona-statelianxiren" style={{ fontSize: "20px", color: "rgba(129, 135, 147, 1)"}} />;
export const IconTopUp = <IconFont type="iconapp_btn_top_up" />;
export const IconSwitch = <IconFont type="iconlog_switch" />;
export const IconApplicationShop = <IconFont type="iconapp_application_shop" />;
export const getIconFromString = (type: string) => <IconFont type={type} />;
export const IconicPcDongaoAdd = <IconFont type="iconic_pc_dongao_add" />;
export const IconbtnTopUp = <IconFont type="iconbtn_top_up" />;
export const IconbtnTopDown = <IconFont type="iconbtn_top_down" />;
export const IconScale = <IconFont type="icon_scale" />;
export const IconClearcCache = <IconFont type="icon_clear_cache" />;
export const IconWangluo = <IconFont type="iconwangluo" style={{fontSize: "20px", color: 'rgba(0, 91, 249, 1)'}}/>
export const IconErWeiMa = <IconFont type="iconerweima" style={{fontSize: "20px", color: 'rgba(144, 0, 216, 1)'}}/>
export const IconAddWorkStatus = <><IconFont type="icontianjia1" />状态</>
